<template>
    <div class="login-wrapper">
        <div class="col-lg-8 offset-lg-2">
            <div class="container">
                <div class="box"></div>
                <div class="container-forms">
                    <div class="container-info">

                        <div class="info-item">
                            <div class="table">
                                <div class="table-cell">
                                    <h4 class="text-center mb-4 text-white">ورود </h4>
                                    <button class="btn" @click="swipeLoginForm">
                                        ورود
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!--<div class="info-item">-->
                            <!--<div class="table">-->
                                <!--<div class="table-cell">-->
                                    <!--<h4 class="text-center mb-4 text-white">ورود به روش دریافت پیامک</h4>-->
                                    <!--<button class="btn" @click="swipeLoginForm">-->
                                        <!--ورود-->
                                    <!--</button>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                    <div class="container-form">
                        <!--<div class="form-item log-in">-->
                            <!--<div class="table">-->
                                <!--<div class="table-cell">-->

                                    <!--<div v-if="!smsSended">-->
                                        <!--<h5>لطفا شماره موبایل خود را وارد کنید</h5>-->
                                        <!--<input class="form-control round" name="MobileNo" type="text"-->
                                               <!--placeholder="شماره موبایل" v-model="loginModel.cellPhone1"-->
                                               <!--:disabled="smsSended"/>-->
                                    <!--</div>-->
                                    <!--<div v-else>-->
                                        <!--<h5>لطفا کد ارسال شده را وارد کنید</h5>-->
                                        <!--<input class="form-control round" name="MobileNo" type="text"-->
                                               <!--placeholder="کد تائید" v-model="loginModel.smsCode"/>-->
                                    <!--</div>-->
                                    <!--<button class="btn btn-primary" @click="swipeSignUpForm(false)">-->
                                        <!--ورود-->
                                    <!--</button>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <div class="form-item log-in">
                        <!--<div class="form-item sign-up">-->
                            <div class="table">
                                <div class="table-cell">
                                    <div>
                                        <h5>لطفا شماره همراه و کد ملی خود را وارد کنید</h5>
                                        <input class="form-control round" name="Username" type="text"
                                               placeholder="شماره همراه" v-model="loginModel.cellPhone1"
                                               @keypress.enter="swipeSignUpForm(true)"/>
                                        <input class="form-control round" name="Password" type="text"
                                               placeholder="کد ملی" v-model="loginModel.nationalCode"
                                               @keypress.enter="swipeSignUpForm(true)"/>
                                    </div>
                                    <button class="btn btn-primary" @click="swipeSignUpForm(true)">
                                        ورود
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <transition
                    mode="out-in"
                    name="fade-long">
                <preloader v-if="isLoading"/>
            </transition>

        </div>
    </div>
</template>

<script>
    import * as $ from "jquery";
    import Utils from "../_framework/utils/Utils";
    import BaseService from "../_framework/api/BaseService";
    import EventBus from '../_framework/event-bus.js';


    export default {

        data() {
            return {
                userModel: {
                    mobile: null,
                    userName: null,
                    passwordHash: null
                },
                loginModel: {
                    cellPhone1: "",
                    nationalCode: "",
                    smsCode: ""
                },
                isLoading: false,
                loginWithMobileNo: false,
                mobileNumber: "",
                confirmNumber: "",
                loginByMobileText: "ورود با موبایل",
                passwordHash: "",
                smsSended: false,

            }
        },
        mounted() {
            // let t = localStorage.getItem('theme');
            // // console.log("theme = "+ t)
            // if (t === 'dark') {
            //     EventBus.$emit('theme', 'dark');
            //     localStorage.setItem("theme", 'dark');
            // } else if (t === 'light') {
            //     EventBus.$emit('theme', 'light');
            //     localStorage.setItem("theme", 'light');
            // } else {
            //     EventBus.$emit('theme', 'light');
            //     localStorage.setItem("theme", 'light');
            // }
            if (this.$route.query.unauthorized) {
                this.$noty.error('لطفا ابتدا وارد حساب کاربری خود شوید!');
            }
            $("body").addClass("login");
        },
        methods: {
            swipeLoginForm() {
                // console.log("asdasd")
                $(".container").toggleClass("log-in");
                /*$(".info-item .btn").click(function(){

                });*/
            },
            swipeSignUpForm(bool) {
                if (!bool) {
                    if (this.smsSended) {

                        new BaseService("Login", "/ConfirmSmsCode").create(this.loginModel).then(response => {
                            // console.log(response.data);
                            this.isLoading = false;
                            const userName = response.data.data.userdata.firstName + ' ' + response.data.data.userdata.lastName;
                            // const mobile = response.data.data.userdata.mobile;
                            const userId = response.data.data.userdata.id;
                            if (response.data.data.userdata.image !== "") {
                                EventBus.$emit("setProfileImage",
                                    // this.validateProfilePlaceholder(this.validateImageUrl(this.validateProfileImage(response.data.data.userdata.userImage))));
                                    this.validateImageUrl(response.data.data.userdata.image));
                            }

                            localStorage.setItem("role", "user");
                            // }
                            if (response.data.data.token) {
                                localStorage.setItem("token", response.data.data.token);
                                localStorage.setItem("userName", userName);
                                // localStorage.setItem("mobile", mobile);
                                localStorage.setItem("userId", userId);

                                EventBus.$emit('userName', userName);
                                EventBus.$emit('userId', userId);
                            } else {
                                this.$noty.error("کاربر شناسایی نشد");
                            }
                            this.$noty.success('ورود با موفقیت انجام شد', {timeout: 1000});
                            this.$router.push({name: 'home'});
                            // if (response.data.data.userRole[0] === "SuperAdmin") {
                            //     this.$router.push({name: 'mainItems'});
                            // } else {
                            //     this.$router.push({name: 'editItem'});
                            // }
                            this.userModel.userName = null;
                            this.userModel.passwordHash = null;
                            this.smsSended = false;
                        }).catch(error => {
                            this.isLoading = false;
                            $(".container").removeClass("active");
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    } else {

                        new BaseService("Login", "/SendSmsCode").create(this.loginModel).then(response => {
                            // console.log(response.data);
                            this.smsSended = true;
                            this.$noty.success('کد ارسال شده را وارد کنید', {timeout: 1000});
                        }).catch(error => {
                            this.isLoading = false;
                            $(".container").removeClass("active");
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    }

                } else {
                    // Login
                    //$(".container").addClass("active");
                    // console.log(this.userModel)
                    this.isLoading = true;
                    new BaseService("Login", "/LoginWithUsername").create(this.loginModel).then(response => {
                        // console.log(response.data);
                        this.isLoading = false;
                        const userName = response.data.data.userdata.firstName + ' ' + response.data.data.userdata.lastName;
                        // const mobile = response.data.data.userdata.mobile;
                        const userId = response.data.data.userdata.id;
                        if (response.data.data.userdata.image !== null&& response.data.data.userdata.image !== "") {
                            EventBus.$emit("setProfileImage",
                                // this.validateProfilePlaceholder(this.validateImageUrl(this.validateProfileImage(response.data.data.userdata.userImage))));
                                this.validateImageUrl(response.data.data.userdata.image));
                        }

                        localStorage.setItem("role", "user");
                        // }
                        if (response.data.data.token) {
                            localStorage.setItem("token", response.data.data.token);
                            localStorage.setItem("userName", userName);
                            // localStorage.setItem("mobile", mobile);
                            localStorage.setItem("userId", userId);
                            localStorage.setItem("setProfileImage", this.validateImageUrl(response.data.data.userdata.image));

                            EventBus.$emit('userName', userName);
                            EventBus.$emit('userId', userId);
                            // console.log(this.validateImageUrl(response.data.data.userdata.userImage));
                        } else {
                            this.$noty.error("کاربر شناسایی نشد");
                        }
                        this.$noty.success('ورود با موفقیت انجام شد', {timeout: 1000});
                        this.$router.push({name: 'home'});
                        // if (response.data.data.userRole[0] === "SuperAdmin") {
                        //     this.$router.push({name: 'mainItems'});
                        // } else {
                        //     this.$router.push({name: 'home'});
                        // }
                        this.userModel.userName = null;
                        this.userModel.passwordHash = null;
                        this.smsSended = false;
                    }).catch(error => {
                        this.isLoading = false;
                        $(".container").removeClass("active");
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }

                /*$(".container-form .btn").click(function(){

                });*/
            }

        },
        beforeRouteLeave(to, from, next) {
            $("body").removeClass("login");
            next()
        }
    }
</script>

<style lang="scss" scoped>
    .form-control {
        display: block;
        width: 100%;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem .75rem;
        font-size: 0.85rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057 !important;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 3rem;
        -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    }

    .form-control:focus {
        border-color: #ced4da;
        border-width: 1px;
        background-color: #ffffff;
        box-shadow: 0 0 15px -5px rgba(0, 0, 0, 0.25);
    }
</style>
